import * as z from "zod";

const errorMapping = {
    // username_min_character: "ชื่อผู้ใช้งานต้องมีจำนวนตัวอักษรมากกว่า 5 ตัวขึ้นไป",
    // username_max_character: "ชื่อผู้ใช้งานต้องมีจำนวนตัวอักษรไม่เกิน 50 ตัว",
    // username_empty: "กรุณาระบุชื่อรหัสสมาชิก / เลขประจำตัวประชาชน",
    email_empty: "login.email_empty",
    email_invalid: "login.email_invalid",
    password_min_character: "login.password_min_character",
    password_empty: "login.password_empty",
    password_max_character: "login.password_max_character",
    phone_number_empty: "login.phone_number_empty",
    phone_number_invalid: "login.phone_number_invalid",
    phone_number_max_character: "login.phone_number_max_character",
    phone_number_min_character: "login.phone_number_min_character",
    phone_number_not_match: "login.phone_number_not_match",
    phone_number_not_found: "login.phone_number_not_found",
};

export const signinEmailValidatorSchema = z.object({
    email: z
        .string({
            required_error: errorMapping.email_empty,
        })
        .min(1, {
            message: errorMapping.email_empty,
        })
        .regex(/^[a-zA-Z0-9]([a-zA-Z0-9._-]*[a-zA-Z0-9])?@[a-zA-Z0-9]([a-zA-Z0-9.-]*[a-zA-Z0-9])?\.[a-zA-Z]{2,}$/, {
            message: errorMapping.email_invalid,
        }),
    password: z
        .string({
            required_error: errorMapping.password_empty,
        })
        .min(1, {
            message: errorMapping.password_empty,
        })
        .min(8, {
            message: errorMapping.password_min_character,
        })
        .max(20),
});

export const signinPhoneValidatorSchema = z.object({
    phone_number: z
        .string({
            required_error: errorMapping.phone_number_empty,
        })
        .min(1, {
            message: errorMapping.phone_number_empty,
        })
        .max(10, {
            message: errorMapping.phone_number_max_character,
        })
        .regex(/^0(10|[6-9]\d)\d{7}$/, {
            message: errorMapping.phone_number_invalid,
        }),
});
export type SignInPhoneValidatorSchema = z.infer<typeof signinPhoneValidatorSchema>;
export type SignInEmailValidatorSchema = z.infer<typeof signinEmailValidatorSchema>;
